import axios from 'axios';
import TokenService from './TokenService';
import VueJwtDecode from 'vue-jwt-decode';

const Repository = {
  init(baseURL) {
    axios.defaults.baseURL = baseURL;
  },

  setHeaders() {
    //axios.defaults.headers.common['authorization'] = TokenService.getToken();
    // axios.defaults.headers.common['authorization'] = 'Bearer '+TokenService.getToken();
    // axios.defaults.headers.common['userId'] = VueJwtDecode.decode(
    //   TokenService.getToken()
    // ).userId;
    //axios.defaults.headers.common['userId'] = 3;
    // axios.defaults.headers.common['companyId'] = VueJwtDecode.decode(
    //   TokenService.getToken()
    // ).companyId;
  },

  removeHeader() {
    axios.defaults.headers.common = {};
  },

  get(resource) {
    return axios.get(resource);
  },

  post(resource, data) {
    return axios.post(resource, data);
  },

  postFile(resource, file) {
    const formData = new FormData();
    const headers = { 'Content-Type': 'multipart/form-data' };
    formData.append('attachment', file);
    return axios.post(resource, formData, { headers });
  },

  put(resource, data) {
    return axios.put(resource, data);
  },

  delete(resource) {
    return axios.delete(resource);
  },

  patch(resource, data) {
    return axios.patch(resource, data);
  },

  /**
   * Perform a custom Axios request.
   *
   * data is an object containing the following properties:
   *  - method
   *  - url
   *  - data ... request payload
   *  - auth (optional)
   *    - username
   *    - password
   **/
  customRequest(data) {
    return axios(data);
  }
};

export default Repository;
